module.exports = __webpack_public_path__ + "img/logout.0edeb14c.svg";